import 'vant/lib/switch/index.less'

// 依赖
import '../preview-text/style'
